import {
  Divider,
  Flex,
  Text,
  Picture,
  type PictureProps,
  Strikeout,
} from '@farmersdog/corgi-x';

import { CheckmarkList } from '../CheckmarkList';
import { GettingStartedBadges } from '../GettingStartedBadges/GettingStartedBadges';

import styles from './GettingStartedCard.module.css';

interface GettingStartedCardProps {
  headline: string;
  listItems: string[];
  strikeoutPrice?: string;
  actualPrice: string;
  badges?: string[];
  imageSources: PictureProps['sources'];
  imageAltText: string;
}

/** A card within the Getting Started module on the Signup Recipes page */
export const GettingStartedCard = ({
  headline,
  listItems,
  strikeoutPrice,
  actualPrice,
  badges,
  imageSources,
  imageAltText,
}: GettingStartedCardProps) => {
  return (
    <div className={styles.cardWrapper}>
      <Text variant="heading-22" bold align="center" as="h3" bottomSpacing="sm">
        {headline}
      </Text>
      <Picture
        loading="lazy"
        className={styles.cardImage}
        sources={imageSources}
        alt={imageAltText}
      />
      <CheckmarkList listItems={listItems} />
      <Divider color="Oyster2" width={1} />
      <Flex
        direction="row"
        gap="xs"
        alignItems="baseline"
        justify="center"
        className={styles.priceContainer}
      >
        {strikeoutPrice && (
          <Text variant="heading-16" color="Charcoal2">
            <Strikeout>{strikeoutPrice}</Strikeout>
          </Text>
        )}
        <Text variant="heading-16" color="Kale2" bold>
          {actualPrice}
        </Text>
      </Flex>
      <GettingStartedBadges badges={badges} />
    </div>
  );
};
